module.exports = __webpack_public_path__ + "static/media/tasks.95734275.svg";